import DOMPurify from "dompurify"

const ALLOWED_TAGS = [
  "a", "b", "blockquote", "br", "code", "div", "em", "h1", "h2", "h3", "h4",
  "h5", "h6", "hr", "i", "img", "li", "ol", "p", "pre", "span", "strong",
  "sub", "sup", "table", "tbody", "td", "tfoot", "th", "thead", "tr", "u", "ul",
  "figure", "figcaption", "small", "mark", "details", "summary",
]

const ALLOWED_ATTR = [
  "href", "title", "target", "rel", "src", "alt", "width", "height",
  "class", "id", "lang", "dir", "colspan", "rowspan",
]

export function sanitizeHtml(input: string | null | undefined): string {
  if (!input) return ""
  return DOMPurify.sanitize(input, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ["script", "style", "iframe", "object", "embed", "link", "meta"],
    FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover", "formaction"],
    RETURN_TRUSTED_TYPE: false,
  })
}
